import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { LanguageProvider } from './context/LanguageContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import OrderStatus from './pages/OrderStatus';
import Checkout from './pages/Checkout';
import Terms from './pages/Terms';
import Dashboard from './pages/Dashboard';
import ResetPassword from './pages/ResetPassword';
import TopUp from './pages/TopUp';
import AuthPage from './pages/AuthPage';
import Status from './pages/Status';
import './styles/App.css';

const SplashScreen = ({ onFinish }) => {
  const [phase, setPhase] = useState('logo');

  useEffect(() => {
    const t1 = setTimeout(() => setPhase('text'), 600);
    const t2 = setTimeout(() => setPhase('dots'), 1100);
    const t3 = setTimeout(() => setPhase('fade'), 2600);
    const t4 = setTimeout(() => onFinish(), 3100);
    return () => { clearTimeout(t1); clearTimeout(t2); clearTimeout(t3); clearTimeout(t4); };
  }, [onFinish]);

  return (
    <div className={`splash-screen ${phase === 'fade' ? 'splash-fade' : ''}`}>
      <div className="splash-content">
        <img
          src="/logo2.png"
          alt="Fast Boost"
          className={`splash-logo ${phase !== 'logo' ? 'splash-logo-visible' : ''}`}
        />
        <h1 className={`splash-title ${['text','dots','fade'].includes(phase) ? 'splash-title-visible' : ''}`}>
          Fast <span>Boost</span>
        </h1>
        <div className={`splash-dots ${['dots','fade'].includes(phase) ? 'splash-dots-visible' : ''}`}>
          <span className="splash-dot" />
          <span className="splash-dot" />
          <span className="splash-dot" />
        </div>
      </div>
    </div>
  );
};

function App() {
  const [showSplash, setShowSplash] = useState(() => {
    if (sessionStorage.getItem('fb_splash_shown')) return false;
    return true;
  });

  const handleSplashFinish = React.useCallback(() => {
    setShowSplash(false);
    sessionStorage.setItem('fb_splash_shown', '1');
  }, []);

  if (showSplash) return <SplashScreen onFinish={handleSplashFinish} />;

  return (
    <LanguageProvider>
      <AuthProvider>
        <Router>
          <div className="app-container">
            <Navbar />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/order-status" element={<OrderStatus />} />
              <Route path="/checkout/:orderId" element={<Checkout />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/reset-password/:token" element={<ResetPassword />} />
              <Route path="/topup" element={<TopUp />} />
              <Route path="/login" element={<AuthPage initialTab="login" />} />
              <Route path="/register" element={<AuthPage initialTab="signup" />} />
              <Route path="/status" element={<Status />} />
            </Routes>
            <Footer />
          </div>
        </Router>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;